// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import SignUp from './SignUp';

// Types
import type { State } from 'types/redux';
import type { Props } from './SignUp';

// Selectors
import { getEmail } from 'store/reducers/appointment/contactInfo/selectors';
import {
  isRecaptchaEnabledOnRegisterUser,
  getRecaptchaToken
} from 'store/reducers/dealerSettings/selectors';
import { getLanguageCode } from 'store/reducers/dealerLocale/selectors';

// Actions
import { signUp } from 'store/reducers/login/actions';
import { gtmUserEvent, gtmRecaptchaEvent } from 'store/reducers/gtm/actions';
import { setRecaptchaToken } from 'store/reducers/userInteractions/actions';

const mapStateToProps = (state: State): $Shape<Props> => ({
  email: getEmail(state),
  isRecaptchaEnabledOnRegisterUser: isRecaptchaEnabledOnRegisterUser(state),
  languageCode: getLanguageCode(state),
  recaptchaToken: getRecaptchaToken(state)
});

const mapDispatchToProps = {
  signUp,
  gtmUserEvent,
  setRecaptchaToken,
  gtmRecaptchaEvent
};

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SignUp);



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/CreateProfile/components/SignUp/SignUpContainer.js